const AB_TEST_API_URL = 'https://ttmetrics.jcpenney.com/m2/jcpenney/ubox/raw';
export default {
    AB_TEST_API_URL,
};
